module.exports = __webpack_public_path__ + "static/bsas003-ebf70b09d81181d62d81ca5f23da858a.jpg";